<serviceos-ng-card *ngIf="contactDetails$ | async as contactDetails">
    <span class="title">{{ contactDetails?.title }}</span>
    <div class="content">
        <p class="description" *ngIf="contactDetails.description">{{ contactDetails.description }}</p>
        <serviceos-web-email-form *ngIf="contactDetails.email"></serviceos-web-email-form>
        <serviceos-web-addresses-form *ngIf="contactDetails.addresses"></serviceos-web-addresses-form>
        <serviceos-web-phones-form *ngIf="contactDetails.phones"></serviceos-web-phones-form>
    </div>
</serviceos-ng-card>
